
export const ADD_VIDEO = 'ADD_VIDEO';
export const UPDATE_LIST = 'UPDATE_LIST';
export const GET_INFO = 'GET_INFO';
export const GET_CHANNEL_INFO = 'GET_CHANNEL_INFO';
export const ADD_USER = 'ADD_USER';
export const GET_LISTS_INFO = 'GET_LISTS_INFO';

export const GET_ONE_LIST = 'GET_ONE_LIST';
